import Game from "./Game.js";
import AContainer from "../../library/ExtendedObjects/AContainer.js";
import gameData from "../../gameData.js";
import ABCyaLib from "@abcya/abcya_lib";
import ABCyaPhaser from "@abcya/abcya_phaser";

export default class Game_Menu extends AContainer
{
    /**
     * @param {Game} scene 
     */
    constructor(scene)
    {
        super(scene);
        this.scene = scene;

        this.overlay = this.create(0, 0, "bg_forest");
        this.overlay.tint = 0x000000;
        this.overlay.setInteractive();

        this.emitter = this.scene.add.particles(this.scene.defaultAtlas, 'SnakeParticle').createEmitter({
            tint: [0xFFFEE0, 0xff0000],
            scale: { start: .5, end: 0 },
            speed: {min: -100, max: 100 },
            quantity: 200
        });
        this.emitZone = {
            source: new Phaser.Geom.Rectangle(-275, -175, 550, 350),
            type: 'edge',
            quantity: 50
        };
        this.emitter.setEmitZone(this.emitZone);
        this.emitter.stop();
        this.add(this.emitter.manager);

        this.menuContainer = this.scene.add.container(0, 0);
        this.add(this.menuContainer);

        const config = ABCyaLib.Environment.instance.gameConfig;
       
        const back =this.scene.addImage(0, 0, "popup_menu", this.menuContainer);
        this.resumeButton = this.scene.addButton(180, 110, "BTN_menuResumeOff", {frameOnDown: "BTN_menuResumeOn"}, ()=>{
            this.hidePopup();
        }, this.menuContainer);
        this.overlay.on("pointerdown", ()=>{
            this.hidePopup();
        });
        this.homeButton = this.scene.addButton(180, 30, "BTN_menuHomeOff", {frameOnDown: "BTN_menuHomeOn"}, ()=>{
            scene.transitionBushes.transitionIn("Intro");
        }, this.menuContainer);
        this.snakeOverlay = this.scene.addImage(5, 4, (gameData.curSnakeIndex + 1) + "_menu", this.menuContainer);

        let type = gameData.curGameType;

        if(config.subtitle === null) {
          this.countButton = this.scene.addButton(62, 65, type == "COUNT" ? "BTN_countOn" : "BTN_countOff", {frameOnDown: "BTN_countOn"}, ()=>{
              if(gameData.curGameType == "COUNT") return;
              gameData.curGameType = "COUNT";
              scene.transitionBushes.transitionIn("Game");
          }, this.menuContainer).setScale(.7);
          this.listenButton = this.scene.addButton(-47.5, 65, type == "LISTEN" ? "BTN_listenOn" : "BTN_listenOff", {frameOnDown: "BTN_listenOn"}, ()=>{
              if(gameData.curGameType == "LISTEN") return;
              gameData.curGameType = "LISTEN";
              scene.transitionBushes.transitionIn("Game");
          }, this.menuContainer).setScale(.7);
          this.readButton = this.scene.addButton(-155, 65, type == "READ" ? "BTN_readOn" : "BTN_readOff", {frameOnDown: "BTN_readOn"}, ()=>{
              if(gameData.curGameType == "READ") return;
              gameData.curGameType = "READ";
              scene.transitionBushes.transitionIn("Game");
          }, this.menuContainer).setScale(.7);
        }
        else{
          back.setFrame('variant/popup_menu');
          this.resumeButton.setPosition(-66, 82);
          this.homeButton.setPosition(75, 82);
        }

        this.snakeIcons = [];
        this.selectedIcon = null;
        for(let i = 0 ; i < gameData.snakeTypes.length; i++)
        {
            let snakeIcon = this.scene.addImage(-195 + (i * 56), - 93, (i+1)+"_menuprev", this.menuContainer);
            if(i!=0)
            {
                let lockImage = this.scene.addImage(snakeIcon.x - 15, snakeIcon.y + 15, "menu_lock", this.menuContainer);
                lockImage.setScale(.3);
                snakeIcon.lock = lockImage;
            }   

            snakeIcon.xOrigin = snakeIcon.x;
            snakeIcon.yOrigin = snakeIcon.y;
            snakeIcon.index = i;
            snakeIcon.isLocked = i!=0;
            
            if(gameData.curSnakeIndex == i) this.selectSnakeIcon(snakeIcon);

            if(gameData.numUnlocked < i)
            {
                snakeIcon.tint = 0xaaaaaa;
            }
            else
            {
                snakeIcon.setInteractive();
                snakeIcon.on("pointerdown", () => {
                    this.selectSnakeIcon(snakeIcon);
                });
            } 
            this.snakeIcons.push(snakeIcon);
        }

        this.meterBG = this.scene.addImage(0, -42, "menu_progressbar2", this.menuContainer);
        this.meter = this.scene.addNineSlice(-206, -41.5, "menu_progressbar1", 0, 0, 9, 9, 20, 16, this.menuContainer).setOrigin(0, .5);
        this.meterStartWidth = this.meter.displayWidth;
        this.meterEndWidth = 412;

        this.menuContainer.alpha = 0;
        this.overlay.alpha = 0;
    }

    selectSnakeIcon(icon)
    {
        if(this.selectedIcon != null) 
        {
            this.selectedIcon.setFrame((this.selectedIcon.index+1)+"_menuprev", false, false);
            this.selectedIcon.setPosition(this.selectedIcon.xOrigin, this.selectedIcon.yOrigin);
        }
        this.selectedIcon = icon;
        this.selectedIcon.y = this.selectedIcon.yOrigin - 3;
        this.selectedIcon.x = this.selectedIcon.xOrigin - 2;
        this.selectedIcon.setFrame((this.selectedIcon.index+1)+"_menuprev_select", false, false);
        gameData.curSnakeIndex = this.selectedIcon.index;

        for(let i = 0; i < this.scene.snakes.length; i++)
        {
            this.scene.snakes[i].updateSnakeImage();
        }
        if(this.scene.ui.snakeMenu) this.scene.ui.snakeMenu.refreshButtonImages();

        this.scene.killTween(this.menuContainer);
        this.scene.addTween(this.menuContainer, 250, {scaleX: 0, scaleY: 1.2}, Phaser.Math.Easing.Sine.In, ()=>{
            this.snakeOverlay.setFrame((gameData.curSnakeIndex + 1) + "_menu", false, false);
            this.scene.addTween(this.menuContainer, 800, {scaleX: 1, scaleY: 1}, "Back");
        });
    }

    animateMeter()
    {
        let maxUnlocked = 7;
        let curUnlocked = gameData.numUnlocked > maxUnlocked ? maxUnlocked : gameData.numUnlocked;
        let meterDiff = this.meterEndWidth - this.meterStartWidth;
        let meterIncrements = meterDiff/maxUnlocked;
        let destWidth = this.meterStartWidth + meterIncrements * curUnlocked;
        
        this.scene.addTween(this.meter, 500, {width: destWidth, onUpdate: ()=>{
            let curUnlockPos = Math.floor((this.meter.width - this.meterStartWidth) / meterIncrements);
            if(this.snakeIcons[curUnlockPos].isLocked)
            {
                let snakeIcon = this.snakeIcons[curUnlockPos];
                snakeIcon.isLocked = false;
                let lock = this.snakeIcons[curUnlockPos].lock;
                this.scene.addTween(lock, 300, {scaleX: .6, scaleY: .6, angle: -5, y: lock.y - 30}, Phaser.Math.Easing.Sine.Out, ()=>{
                    lock.setFrame("menu_unlock", false, false);
                    this.scene.addTween(lock, 700, {alpha: 0, y: lock.y - 10, angle: -30}, Phaser.Math.Easing.Sine.Out);
                });

                this.scene.addDelay(300, ()=>{
                    let emitter = this.scene.add.particles(this.scene.defaultAtlas, 'SnakeParticle').createEmitter({
                        x: snakeIcon.x,
                        y: snakeIcon.y,
                        tint: gameData.snakeTypes[curUnlockPos].colors,
                        scale: { start: .5, end: 0 },
                        speed: {min: -50, max: 50 },
                        alpha: {start: 0, end: 1}
                    });
                    this.menuContainer.add(emitter.manager);
                    emitter.explode(100);
                });
                this.scene.addTween(snakeIcon, 200, {scaleX: 1.2, scaleY: 1.2, angle: -5}, Phaser.Math.Easing.Sine.Out, ()=>{
                    snakeIcon.tint = 0xffffff;
                    snakeIcon.setInteractive();
                    snakeIcon.on("pointerdown", () => {
                        this.selectSnakeIcon(snakeIcon);
                    });
                    this.scene.addTween(snakeIcon, 1000, {scaleX: 1, scaleY: 1, angle: 0}, "Elastic");
                });
            }
            
        }}, Phaser.Math.Easing.Sine.Out);
    }

    displayPopup()
    {
        this.scene.killTween(this.menuContainer);
        this.scene.killTween(this.overlay);

        if(gameData.numUnlocked >= gameData.snakeTypes.length){
          this.emitter.tint.propertyValue = gameData.snakeTypes[gameData.snakeTypes.length-1].colors;
        } else {
          this.emitter.tint.propertyValue = gameData.snakeTypes[gameData.numUnlocked].colors;
        }

        this.menuContainer.setScale(1.2);

        this.scene.addTween(this.overlay, 300, {alpha: .4});
        this.scene.addTween(this.menuContainer, 300, {alpha: 1});
        this.scene.addTween(this.menuContainer, 1000, {scaleX: 1, scaleY: 1}, "Bounce", ()=>{
            this.animateMeter();
        });
        this.scene.addDelay(300, ()=>{
            this.emitter.explode(600);
            this.scene.addDelay(200, ()=>{
                this.emitter.explode(300);
                this.scene.addDelay(100, ()=>{
                    this.emitter.explode(150);
                });
            });
        });
    }

    hidePopup()
    {
        this.scene.killTween(this.menuContainer);
        this.scene.killTween(this.overlay);

        this.scene.addTween(this.menuContainer, 300, {alpha: 0, scaleX: 0, scaleY: 0});
        this.scene.addTween(this.overlay, 300, {alpha: 0});
    }
}